import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { paymentAPI } from 'redux/paymentAPI';
import { RefundRequest } from '@payer-admin-ui/api/src/cardpayments/requests/RefundRequest';
import { ActionState, PaymentIdObject } from '@payer-admin-ui/components-v2/src/types/state';
import { patch } from '@payer-admin-ui/components-v2/src/functions/lodashExtensions';
import { RefundAndCreditResponse } from '@payer-admin-ui/api/src/cardpayments/responses/RefundAndCreditResponse';
import { showSnackbar } from 'redux/snackbar';
import i18n from 'i18next';
import { fetchPayment } from '../paymentsGlobalState';

export const refundCardPayment = createAsyncThunk<RefundAndCreditResponse, PaymentIdObject & RefundRequest>(
  'payments/actions/RefundCardPaymentModal/refund',
  async ({ paymentId, amount, transactionDescription }, { dispatch }) => {
    const result = await paymentAPI.actions.refundCardPayment({ paymentId, amount, transactionDescription });
    dispatch(fetchPayment({ id: paymentId }));
    dispatch(
      showSnackbar(i18n.t('payments.actions.refundCardPayment.success', { paymentId }), { severity: 'success' }),
    );
    return result;
  },
);

const refundCardPaymentModalSlice = createSlice({
  name: 'payments/actions/RefundCardPaymentModal',
  initialState: {} as ActionState,
  reducers: {
    reset: (state, { payload: { paymentId } }: PayloadAction<PaymentIdObject>) => {
      delete state[paymentId];
    },
  },
  extraReducers: builder => {
    builder.addCase(refundCardPayment.pending, (state, { meta: { arg } }) => {
      patch(state, {
        [arg.paymentId]: { isFetching: true, success: undefined, error: undefined },
      });
    });
    builder.addCase(refundCardPayment.fulfilled, (state, { meta: { arg } }) => {
      patch(state, {
        [arg.paymentId]: { isFetching: false, success: true, error: undefined },
      });
    });
    builder.addCase(refundCardPayment.rejected, (state, { meta: { arg }, error }) => {
      patch(state, {
        [arg.paymentId]: { isFetching: false, success: false, error },
      });
    });
  },
});

export const {
  actions: { reset },
  reducer: refundCardPaymentModalReducer,
} = refundCardPaymentModalSlice;
